export const getComponentId = (networkId, netComponent, componentType) => {
  let id;
  switch (componentType) {
    case 'region':
      id = netComponent.regionId;
      break;
    case 'gw':
      id = netComponent.gatewayId;
      break;
    case 'tunnel':
      id = netComponent.tunnelId;
      break;
    default:
      id = networkId ? networkId : netComponent.networkId;
  }
  return id;
};
